

<template>

    <div id="maquette_config">

        <van-row>

          <!-- <img src="@/assets/Lx_M2.png" style="height:80px"/> --> 

        <van-col class="col_img_maquette" span="9">
            <MaquetteCoA/> 
        </van-col>

        <van-col class="col_img_maquette" span="6"  id="maquette_cable">
            <MaquetteCable/>
        </van-col>

        <van-col class="col_img_maquette" span="9">
            <MaquetteCoB/>
        </van-col>
        

</van-row>

</div>



<MaquetteChaussette/>



<MaquetteSelection/>


        </template>
        
        
        <script>
        import MaquetteCable from './MaquetteCable.vue'
        import MaquetteCoA from './MaquetteCoA.vue'
        import MaquetteCoB from './MaquetteCoB.vue'
        import MaquetteChaussette from './MaquetteChaussette.vue'
        import MaquetteSelection from './MaquetteSelection.vue'
        export default {
          components: {
            MaquetteCable,
            MaquetteCoA,
            MaquetteCoB,
            MaquetteChaussette,
            MaquetteSelection
          },
          data() {
            return {
                
            }
          },
          created(){
          },
          computed: {
            
          }
        
        
        }
</script>